import {
  Button,
  Modal,
  MODAL_SIZE_MD,
  ModalBody,
  ModalFoot,
  ModalHead
} from 'mailup-web-components'
import { modalExistWelcomeSeriesWorkflow } from 'Pages/Workflow/recoil/state/modals'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

export const ModalExistWelcomeSeriesWorkflow = ({
  show,
  handleCancel,
  handleConfirm
}) => {
  const intl = useIntl()

  const { name } = useRecoilValue(modalExistWelcomeSeriesWorkflow)

  return (
    <Modal
      data-mu-test='modal-existWelcomeSeriesWorkflow'
      show={show}
      showClose
      onClose={handleCancel}
      closeOnOverlayClick
      size={MODAL_SIZE_MD}
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.WelcomeSeries.existWelcomeSeriesWorkflowModalTitle'
        })}
      />
      <ModalBody>
        <p>
          {intl.formatMessage(
            { id: 'Load.WelcomeSeries.existWelcomeSeriesWorkflowModalDescr' },
            {
              strong: (str) => <strong>{str}</strong>,
              NOME: name
            }
          )}
        </p>
      </ModalBody>
      <ModalFoot>
        <Button
          kind='secondary'
          onClick={handleCancel}
          data-mu-test='button-cancel'
        >
          {intl.formatMessage({ id: 'Load.Common.Close' })}
        </Button>
        <Button
          kind='primary'
          onClick={handleConfirm}
          data-mu-test='button-confirm'
        >
          {intl.formatMessage({
            id: 'Load.Common.Modify'
          })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

ModalExistWelcomeSeriesWorkflow.propTypes = {
  show: PropTypes.bool,
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func
}
